"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePassword = void 0;
var react_1 = __importDefault(require("react"));
exports.usePassword = function (initialValue) {
    var _a = react_1.default.useState(initialValue), value = _a[0], setValue = _a[1];
    var _b = react_1.default.useState(true), isHidden = _b[0], setHidden = _b[1];
    var getValue = function () {
        if (isHidden) {
            var length_1 = String(value).length;
            return Array.from(new Array(length_1), function (v, k) { return '﹡'; }).join('');
        }
        else {
            return value;
        }
    };
    var changeValue = function (_value) {
        setValue(_value);
    };
    return {
        value: getValue(),
        onChangeValue: changeValue,
        onChangeHidden: function () { return setHidden(!isHidden); },
    };
};
